import React from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import UploadPlanogram from './UploadPlanogram'; // Import your existing component
import ReloadPlanograms from './ReloadPlanograms'; // Import your new component

function PlanogramPage() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs value={value} onChange={handleChange} aria-label="planogram tabs">
        <Tab label="Upload Planogram" />
        <Tab label="Reload Planograms" />
      </Tabs>
      {value === 0 && <UploadPlanogram />}
      {value === 1 && <ReloadPlanograms />}
    </Box>
  );
}

export default PlanogramPage;
